export abstract class RegexHelper {
	static number(before: number | string = 6, after: number | string = 2, separator: string = ',.') {
		before = (-1 === before ? '' : before.toString())
		after = (-1 === after ? '' : after.toString())
		let expression = `^(-)?[0-9]{1,${before}}([${separator}][0-9]{0,${after}})?$`
		let regex: RegExp = new RegExp(expression);
		return regex;
	}
}
